(function () {
  "use strict";
  if (window.__todOpenAIContextV1) return;
  var state = { version: 2, status: "waiting_for_load", allowed: false };
  window.__todOpenAIContextV1 = state;
  var element = document.currentScript;
  var count = element && element.getAttribute("data-cart-items");
  var hasCart = count === null || !/^\d+$/.test(count) || Number(count) > 0;
  var attribute = "__tod_openai_measurement_v1";
  var consentAt = null, initialized = false, desired = null, written = null;
  var running = false, queued = false, timer = null, attempts = 0, lastConsent = null, retries = 0;
  var loaded = document.readyState === "complete", starting = false;
  function privacyAllowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (!p || typeof p.marketingAllowed !== "function" || typeof p.analyticsProcessingAllowed !== "function") return null;
      return p.marketingAllowed() === true && p.analyticsProcessingAllowed() === true;
    } catch (_) { return null; }
  }
  function cookie(name) {
    var prefix = name + "=", parts = document.cookie.split(";");
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        var value = part.slice(prefix.length);
        if (value && value.length <= 4096 && !/[\u0000-\u001f\u007f]/.test(value)) return value;
      }
    }
    return null;
  }
  function makeContext() {
    if (!state.allowed || !consentAt) return "";
    var context = { version: 1, marketing: true, analytics: true,
      consent_recorded_at: consentAt, source_url: window.location.origin + window.location.pathname };
    var oppref = cookie("__oppref"), obref = cookie("__obref");
    if (oppref) context.oppref = oppref;
    if (obref) context.obref = obref;
    return JSON.stringify(context);
  }
  function updateForms(value) {
    var forms = document.querySelectorAll("form[action]");
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i], url;
      try { url = new URL(form.action, window.location.href); } catch (_) { continue; }
      if (url.origin !== window.location.origin || !/\/cart\/?$/.test(url.pathname)) continue;
      var name = "attributes[" + attribute + "]";
      var input = form.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement("input"); input.type = "hidden"; input.name = name; form.appendChild(input);
      }
      input.value = value;
    }
  }
  async function flush() {
    if (!hasCart) return;
    if (running) { queued = true; return; }
    running = true;
    try {
      do {
        queued = false;
        var value = desired;
        if (value === null || value === written) continue;
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
        var endpoint = new URL(root + "cart/update.js", window.location.origin);
        if (endpoint.origin !== window.location.origin) throw new Error("invalid_cart_origin");
        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 3000);
        try {
          var attrs = {}; attrs[attribute] = value;
          var response = await fetch(endpoint.href, {
            method: "POST", credentials: "same-origin", keepalive: true,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: attrs }), signal: controller.signal
          });
          if (!response.ok) throw new Error("cart_update_failed");
          written = value;
          retries = 0;
          state.status = value ? "context_saved" : "context_cleared";
        } finally { clearTimeout(timeout); }
      } while (queued || desired !== written);
    } catch (_) {
      state.status = "cart_update_failed";
      if (retries < 2) { retries++; setTimeout(function () { void flush(); }, retries * 500); }
    }
    finally { running = false; }
  }
  function setConsent(allowed) {
    if (!initialized || lastConsent === allowed || typeof window.oaiq !== "function") return;
    window.oaiq("consent", allowed); lastConsent = allowed;
  }
  function sync() {
    try {
      var allowed = privacyAllowed();
      if (allowed === null) allowed = false;
      if (allowed && !state.allowed) consentAt = new Date().toISOString();
      state.allowed = allowed;
      if (!allowed) consentAt = null;
      setConsent(allowed);
      desired = makeContext();
      if (hasCart) { updateForms(desired); void flush(); }
      if (allowed && loaded) startSDK();
    } catch (_) { state.status = "context_unavailable"; }
  }
  function schedule() {
    clearTimeout(timer); timer = setTimeout(sync, 100);
  }
  function cartChanged(event) {
    try {
      var data = event && (event.cartData || event.detail && event.detail.cartData);
      hasCart = data && typeof data.item_count === "number" ? data.item_count > 0 : true;
      schedule();
    } catch (_) { state.status = "cart_event_unavailable"; }
  }
  function startSDK() {
    if (initialized) return;
    initialized = true;
    var needsScript = typeof window.oaiq !== "function";
    if (needsScript) {
      var q = function () { q.q.push(arguments); }; q.q = []; window.oaiq = q;
    }
    setConsent(true);
    window.oaiq("init", { pixelId: "821TJriBbx6JPBtzuc7q9h", debug: false });
    if (needsScript) {
      var script = document.createElement("script");
      script.async = true; script.fetchPriority = "low";
      script.src = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
      script.onload = function () { sync(); setTimeout(sync, 500); setTimeout(sync, 2000); };
      script.onerror = function () { state.status = "sdk_unavailable"; };
      (document.head || document.documentElement).appendChild(script);
    } else schedule();
  }
  function ready() { sync(); }
  function loadPrivacy() {
    try {
      if (privacyAllowed() !== null) { ready(); return; }
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.2" }], function (error) {
          if (!error) ready(); else state.status = "privacy_unavailable";
        });
        return;
      }
      if (++attempts < 20) setTimeout(loadPrivacy, 500);
      else state.status = "privacy_unavailable";
    } catch (_) { state.status = "privacy_unavailable"; }
  }
  function begin() {
    if (starting) return;
    starting = true; loaded = true;
    try {
      if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(loadPrivacy, { timeout: 1500 });
      else setTimeout(loadPrivacy, 50);
    } catch (_) { setTimeout(loadPrivacy, 50); }
  }
  document.addEventListener("visitorConsentCollected", sync);
  document.addEventListener("submit", function (event) {
    try {
      var form = event.target;
      if (!form || !form.action) return;
      var url = new URL(form.action, window.location.href);
      if (url.origin === window.location.origin && /\/cart\/?$/.test(url.pathname)) { hasCart = true; sync(); }
    } catch (_) { state.status = "form_unavailable"; }
  }, true);
  document.addEventListener("cart:updated", cartChanged);
  document.addEventListener("visibilitychange", function () { if (loaded && !document.hidden) schedule(); });
  window.addEventListener("pageshow", function () { if (starting) schedule(); });
  try {
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") subscribe(PUB_SUB_EVENTS.cartUpdate, cartChanged);
  } catch (_) { state.status = "theme_events_unavailable"; }
  if (loaded) begin(); else window.addEventListener("load", begin, { once: true });
})();
